// fetchCountries.js
import { message } from "antd";
import { allCoustomers } from "../../endpoints/API";

export const fetchCustomers = async (setCustomers, baseUrl, prodTestUrl) => {
  try {
    const response = await allCoustomers()
    if (response.statusText=='OK') {
      const data = response.data;
      setCustomers(data);
    } else {
      message.error("Failed to fetch customers.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching customers.");
  }
};
